import { defineStore } from 'pinia';

const normalizeAuthPromptMode = (value = '') => {
    const normalized = `${value || ''}`.trim().toLowerCase();
    if (['login', 'register', 'reset-request', 'reset-confirm'].includes(normalized)) {
        return normalized;
    }
    return 'login';
};

export const useAuthPrompt = defineStore('authPrompt', {
    state: () => ({
        dialogOpen: false,
        dialogContext: 'general',
        initialMode: 'login',
        stayOnCurrentRouteOnLogin: false
    }),
    getters: {
        bookmarkDialogOpen: (state) => state.dialogOpen
    },
    actions: {
        openDialog(context = 'general', options = {}) {
            this.dialogContext = `${context || 'bookmark'}`.trim().toLowerCase() || 'bookmark';
            this.initialMode = normalizeAuthPromptMode(options.initialMode || 'login');
            this.stayOnCurrentRouteOnLogin = options.stayOnCurrentRouteOnLogin === true;
            this.dialogOpen = true;
        },
        openLoginDialog(options = {}) {
            this.openDialog(options.context || 'general', {
                ...options,
                initialMode: 'login'
            });
        },
        openRegisterDialog(options = {}) {
            this.openDialog(options.context || 'general', {
                ...options,
                initialMode: 'register'
            });
        },
        openPasswordResetDialog(options = {}) {
            this.openDialog(options.context || 'general', {
                ...options,
                initialMode: 'reset-request'
            });
        },
        openPasswordResetConfirmDialog(options = {}) {
            this.openDialog(options.context || 'general', {
                ...options,
                initialMode: 'reset-confirm'
            });
        },
        openBookmarkDialog() {
            this.openLoginDialog({
                context: 'bookmark',
                stayOnCurrentRouteOnLogin: true
            });
        },
        openProgressDialog() {
            this.openLoginDialog({
                context: 'watch-progress',
                stayOnCurrentRouteOnLogin: true
            });
        },
        openVoteDialog() {
            this.openLoginDialog({
                context: 'vote',
                stayOnCurrentRouteOnLogin: true
            });
        },
        closeDialog() {
            this.dialogOpen = false;
        },
        closeBookmarkDialog() {
            this.closeDialog();
        }
    }
});
